module.exports = __webpack_public_path__ + "static/media/Inter-Regular.515cae74.ttf";